module.exports = __webpack_public_path__ + "media/images/common/services/talkport/logo-97c2a3eac8fcbd398a4a26d166674fa7.png";